import React from 'react';

export interface Header13WAppendixProps {
  appendixNumber: string;
  mainContractNumber: string;
  mainContractDate: string;
  logoSrc?: string;
}

const Header13WAppendix: React.FC<Header13WAppendixProps> = ({
  appendixNumber,
  mainContractNumber,
  mainContractDate,
  logoSrc = '/images/logo/logoweb.webp',
}) => {
  return (
    <>
      {/* Header Block */}
      <div className="pdf-block !relative !mb-10 !pt-4" style={{ minHeight: '120px' }}>
        <div className="!absolute !top-0 !left-0 !w-20 pdf-logo">
          <img
            src={logoSrc}
            alt="BeQ Holdings Logo"
            className="!w-16 !h-16 !object-contain"
          />
        </div>

        <div className="text-center">
          <p className="!text-[12px] !font-bold !uppercase !m-0" style={{ color: '#000' }}>
            CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
          </p>
          <p className="!text-[11px] !m-0" style={{ color: '#000' }}>
            Độc lập – Tự do – Hạnh phúc
          </p>
          <div className="!w-24 !h-[1px] !bg-black !mx-auto !mt-1 !mb-4"></div>

          <h1 className="!text-lg !font-bold !uppercase !mt-6" style={{ color: '#000' }}>
            PHỤ LỤC HỢP ĐỒNG HỢP TÁC ĐẦU TƯ
          </h1>
          <p className="!text-sm">
            Số: <span className="!font-medium">{appendixNumber}</span>
          </p>
        </div>
      </div>

      {/* Legal Basis Section */}
      <div className="text-center !mb-8 !mt-8 pdf-block">
        <div className="!text-xs !text-gray-900 dark:!text-gray-400 !text-left !space-y-1 !mb-6">
          <p>- Căn cứ hợp đồng hợp tác đầu tư số {mainContractNumber || <span className="inline-block border-b border-gray-400 w-32 h-px ml-1 translate-y-[-2px]"></span>} ký ngày {mainContractDate || <span className="inline-block border-b border-gray-400 w-20 h-px ml-1 translate-y-[-2px]"></span>};</p>
          <p>- Căn cứ vào thỏa thuận của các Bên.</p>
        </div>
      </div>
    </>
  );
};

export default Header13WAppendix;
